import axios from 'axios'
import React, { Component } from 'react';
import MobileDetect from 'mobile-detect';
import { connect } from 'react-redux';
import { getCookie } from '../common/utils/cookie';
import * as eventsActions from '../App/events.actions';
import {
    actions as pageInfoActions,
    selectors as pageInfoSelectors,
} from '../common/pageInfo';
import { actions as bookmakersInfoActions } from '../common/bookmakersInfo';
import { actions as bookmakersListActions } from '../common/bookmakersList';
import { actions as modalActions } from '../modals';
import { create as createLogger } from '../common/utils/logger';
import ApiClient from '../common/utils/apiClient'
import { Modal } from '../common/modal';
import { actions as gdprActions } from '../common/gdpr'
import BookmakersSwitcher from '../bookmakersSwitcher';

const logger = createLogger('Root');

const getIsPhone = () => (
    Boolean(new MobileDetect(navigator.userAgent).phone())
);

const getIsTablet = () => (
    Boolean(new MobileDetect(navigator.userAgent).tablet())
);

export class PageRoot extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onCloseGdprModal = this.onCloseGdprModal.bind(this)
        this.onAcceptGdprModal = this.onAcceptGdprModal.bind(this)
    }

    componentWillMount() {
        const apiUrls = ApiClient.getApiUrls()
        const isPhone = getIsPhone();
        const isTablet = getIsTablet();
        const loggedInBookmakers = this.getLoggedInBookmakers(isPhone);

        this.props.initializeLoggedInBookmakers(loggedInBookmakers, apiUrls.v1);
        this.initCustomizeSettingsConfiguration();
        this.props.setDeviceType(isPhone, isTablet);
        this.props.loadAppConfig(isPhone);
        this.props.setApiUrl(apiUrls.v1, apiUrls.v3);

        if (!this.props.selectedBookmaker) {
            this.props.setSelectedBookmaker('#BESTODDS');
        }

        this.props.setInitialized();
    }

    onPopoverClose = () => {
        const { onPopoverClose } = this.props;
        this.onHistoryChanged();
        onPopoverClose();
    }

    onHistoryChanged = (pathName, params) => {
        const { bookmakersList } = this.props;
        if (!params) {
            this.setState({
                currentSkinName: 'noBookmaker',
            });
            return;
        }
        const currentBookmaker = bookmakersList.find(({ feed }) => feed === params.feed);
        const name = (currentBookmaker && currentBookmaker.name) || 'default';

        this.setState({
            currentSkinName: name,
        });
    }

    onCloseGdprModal() {
        const {
            closeGdprPopup,
        } = this.props

        // Instantly close the popup
        closeGdprPopup()
    }

    onAcceptGdprModal() {
        const {
            closeGdprPopup,
            apiUrl,
        } = this.props

        // Instantly close the popup
        closeGdprPopup()

        // In the background, flag that user has seen it
        // Do nothing on success or error
        return axios.get(`${apiUrl}/coral/accept-terms`, {})
            .then()
            .catch()
    }

    getLoggedInBookmakers(isPhone) {
        const { bookmakersList } = this.props;
        return bookmakersList
            .filter(({ availableOnPhone }) => !isPhone || availableOnPhone);
    }

    initCustomizeSettingsConfiguration() {
        const customizeSettings = getCookie('customizeSettings');
        try {
            const userSettings = JSON.parse(customizeSettings);
            this.props.setUseDecimalOdds(!!userSettings.decimalOdds);
        } catch (e) {
            logger.warn('can\'t initialize customize settings configuration');
        }
    }

    renderGdprModal() {
        const isPhone = getIsPhone();
        const {
            gdpr,
        } = this.props

        const height = (isPhone) ? 430 : 540;
        const width = (isPhone) ? 310 : 800;

        return (
            <Modal
                visible
                borderless
                onOverlayClick={this.onCloseGdprModal}
                onClose={this.onCloseGdprModal}
            >
                <div>
                    <div>
                        <iframe
                            className="bs-modal__iframe"
                            title={'Coral'}
                            src={gdpr.url}
                            height={height}
                            width={width}
                        />
                    </div>
                    <div>
                        <button
                            onClick={this.onAcceptGdprModal}
                            className="bs-modal__cta"
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </Modal>
        )
    }

    render() {
        const {
            gdpr,
        } = this.props;

        const gdprPopup = (gdpr.show)
            ? this.renderGdprModal()
            : null

        return (
            <div className="bs-myBookmakersContainer">
                {gdprPopup}
                <BookmakersSwitcher
                    {...this.props}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        bookmakersList,
        gdpr, 
        pageInfo,
        bookmakersInfo: {
            selectedBookmaker,
        },
        modals: {
            globalModal
        }
    } = state

    return {
        selectedBookmaker,
        bookmakersList,
        isPopoverOpened: pageInfoSelectors.isBookmakerSwitcherOpenedSelector(state),
        globalModal,
        gdpr,
        apiUrl: pageInfo.apiUrl,
    };
};

export default connect(mapStateToProps, {
    setApiUrl: pageInfoActions.setApiUrl,
    setDeviceType: pageInfoActions.setDeviceType,
    onPopoverOpen: pageInfoActions.openBookmakerSwitcherPopover,
    onPopoverClose: pageInfoActions.closeBookmakerSwitcherPopover,
    loadAppConfig: pageInfoActions.loadAppConfig,
    setUseDecimalOdds: pageInfoActions.setUseDecimalOdds,
    initializeLoggedInBookmakers: bookmakersListActions.initializeLoggedInBookmakers,
    setSelectedBookmaker: bookmakersInfoActions.setSelectedBookmaker,
    clearGlobalModal: modalActions.clearGlobalModal,
    closeGdprPopup: gdprActions.closeGdprPopup,
    setInitialized: eventsActions.setInitialized,
})(PageRoot);



// WEBPACK FOOTER //
// /src/js/myBookmakersPage/PageRoot.jsx